import { render, staticRenderFns } from "./PersonView.vue?vue&type=template&id=e2f1f410&scoped=true&"
import script from "./PersonView.vue?vue&type=script&lang=js&"
export * from "./PersonView.vue?vue&type=script&lang=js&"
import style0 from "./PersonView.vue?vue&type=style&index=0&id=e2f1f410&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f1f410",
  null
  
)

export default component.exports